import { kilos } from "@/features/portal/components/app-screens";
import { m } from "@/paraglide/messages.js";

const RING = 2 * Math.PI * 70;

/**
 * The watch face we are building: the rest counting down around the clock, and the set that
 * comes after it. 208 × 258 pt, black like every watch face.
 */
export const RestFace = () => (
  <div className="absolute inset-0 flex flex-col items-center px-4 pt-4 pb-5">
    <div className="flex w-full items-center justify-between px-2 text-[15px] font-semibold">
      <span className="text-primary">{m.workout_rest()}</span>
      <span className="tabular-nums">9:41</span>
    </div>
    <div className="relative mt-2 grid size-[150px] place-items-center">
      <svg viewBox="0 0 160 160" className="absolute inset-0 -rotate-90">
        <circle cx="80" cy="80" r="70" className="fill-none stroke-white/15" strokeWidth="11" />
        <circle
          cx="80"
          cy="80"
          r="70"
          className="fill-none stroke-primary"
          strokeWidth="11"
          strokeLinecap="round"
          strokeDasharray={RING}
          strokeDashoffset={RING * 0.38}
        />
      </svg>
      <span className="text-center leading-none">
        <b className="block text-[42px] font-semibold tracking-[-0.03em] tabular-nums">1:24</b>
        <small className="mt-1 block text-[13px] text-white/55 tabular-nums">{m.features_watch_of({ total: "2:15" })}</small>
      </span>
    </div>
    <p className="mt-auto text-center leading-tight">
      <small className="block text-[13px] text-white/55">{m.features_watch_next()}</small>
      <b className="text-[16px] font-semibold tabular-nums">
        {m.workout_values_weighted({ weight: kilos(82.5), reps: 8 })}
      </b>
    </p>
  </div>
);
